<script>
import Layout from '@/Shared/Layout'
export default { layout: Layout }
</script>

<script setup>
import { onMounted } from 'vue'
import { Link, Head } from '@inertiajs/inertia-vue3'
import { replaceS3path } from '@/Shared/helper.js'
import Pagination from '@/Shared/Pagination'
import usePref from '@/Shared/usePref.js'

const props = defineProps({
  brands: Object,
  pref: Object,
})

onMounted(() => {
  usePref(props.pref)
})
</script>

<template>
  <div>
    <Head title="ブランドストーリー" />

    <div class="relative lg:grid items-center">
      <div class="keyvisual relative w-full aspect-[3/2] lg:aspect-auto lg:h-[600px] xl:h-[600px] 2xl:h-[650px]">
        <img class="object-cover object-right lg:object-[80%] xl:object-[75%] 2xl:object-[95%] 3xl:object-right w-full h-full" src="https://img.aandf.co.jp/aandfcojp/img/akimama/keyvisual.webp" alt="" />
      </div>
      <div class="lg:absolute lg:top-1/2 lg:translate-y-[-50%] lg:left-[7%] 2xl:left-[10%]">
        <h2 class="page-title lg:text-[125px] lg:text-left !pb-[30px] lg:pt-0">
          STORY
          <small>ブランドストーリー</small>
        </h2>
        <div class="text-white-shadow mx-auto text-center lg:text-left lg:font-medium mb-[50px] md:mb-[100px] lg:mb-0 leading-[2] text-[calc(5px_+_2.4vw)] xs:text-[15px] xl:text-[14px] 2xl:text-[15px] [&>p]:mb-[20px] lg:[&>p]:mb-[0.8em]">
          <p>長く使える道具。</p>
          <p>たとえ壊れようとも、<br class="sm:hidden" />直しながら、使い続けられる道具たち。</p>
          <p>世界中からそんな一生の友と<br class="sm:hidden" />なり得る道具たちを集めては、<br />アウトドアズマンに広く紹介してきたのが、<br class="sm:hidden" />1977年創業のA&amp;F。</p>
          <p>数々のブランドたちは、<br />なぜA&amp;Fとの関わりを持って行くように<br class="sm:hidden" />なったのだろう。</p>
          <p>A&amp;Fにまつわる<br class="sm:hidden" />BRAND STORYを紐解きます。</p>
          <p class="text-[2.6vw] xs:text-[70%] leading-[1.8] !mb-0">
            ※このページは、<a href="https://www.a-kimama.com/" target="_blank">Akimamaにて2018年に連載の<br />「A&amp;F ALL STORIES」</a>を掲載しています。
          </p>
        </div>
      </div>
    </div>

    <div class="mx-auto my-[50px] sm:my-[100px] px-[calc(5vw_+_10px)] xs:px-[40px] md:px-[60px] lg:px-0 max-w-[500px] sm:max-w-[900px]">
      <div class="mx-auto grid gap-[30px] md:gap-[40px] lg:gap-[50px] grid-cols-1 sm:grid-cols-2">
        <div v-for="item in props.brands.data" :key="item.akimamaID" class="relative [.no-touch_&]:aspect-[3/2]">
          <div class="hover-item card group [.no-touch_&]:!absolute w-full !min-w-0 !max-w-none">
            <Link :href="`/brandstory/${item.akimamaSlug}`" class="">
              <img :src="replaceS3path(item.akimamaThumb)" alt="item.akimamaTitle" class="w-full" />
              <p class="title p-[20px] [.no-touch_&]:!px-[20px] [.no-touch_&]:group-hover:!p-[20px] font-semibold !text-[13px] leading-[1.5]">{{ item.akimamaTitle }}</p>
            </Link>
          </div>
        </div>
      </div>
      <pagination :links="brands.links" />
    </div>
  </div>
</template>
